import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface ITeamMemberSessionItem {
  id: string;
  user: number;
  username: string | null;
  session_token: string;
  start_time: string; // ISO string
  end_time: string | null; // ISO string
  last_ping_time: string | null; // ISO string
  uptime_minutes: number;
  downtime_minutes: number;
  is_active: boolean;
  ip_address: string | null;
  user_agent: string | null;
  location: {
    ip: string;
    asn: string;
    org: string;
    city: string;
    in_eu: boolean;
    postal: string;
    region: string;
    country: string;
    network: string;
    version: string;
    currency: string;
    latitude: number;
    timezone: string;
    languages: string;
    longitude: number;
    utc_offset: string;
    country_tld: string;
    region_code: string;
    country_area: number;
    country_code: string;
    country_name: string;
    currency_name: string;
    continent_code: string;
    country_capital: string;
    country_code_iso3: string;
    country_population: number;
    country_calling_code: string;
  } | null;
  meta?: {
    os?: { family?: string | null; version?: string | null } | null;
    device?: {
      brand?: string | null;
      model?: string | null;
      family?: string | null;
    } | null;
    browser?: { family?: string | null; version?: string | null } | null;
    ua_string?: string | null;
    is_pc?: boolean;
    is_bot?: boolean;
    is_mobile?: boolean;
    is_tablet?: boolean;
    is_touch_capable?: boolean;
  } | null;
  created_at: string; // ISO string
  updated_at: string; // ISO string
}

export interface ITeamMemberSessionsResponse {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from: number;
  to: number;
  results: ITeamMemberSessionItem[];
}

export interface TeamMemberSessionsParams {
  user_id: number | string;
  page?: number;
  per_page?: number;
}

export const useTeamMemberSessions = (
  params: TeamMemberSessionsParams,
  enabled: boolean = true
) => {
  return useQuery<ITeamMemberSessionsResponse, Error>({
    queryKey: ["team-members-sessions", params],
    enabled: enabled && !!params?.user_id,
    queryFn: async () => {
      const query: Record<string, string | number | boolean> = {
        user_id:
          typeof params.user_id === "string"
            ? params.user_id
            : Number(params.user_id),
      };
      if (typeof params.page !== "undefined") query.page = params.page;
      if (typeof params.per_page !== "undefined")
        query.per_page = params.per_page;
      const response = await httpService.get<ITeamMemberSessionsResponse>(
        API_CONFIG.path.teamMembersSessions,
        query
      );
      return response;
    },
  });
};
